const isEmpty = (arr) => Array.isArray(arr) && !arr.length;

export default isEmpty;
